import React from 'react';
import './AdminPage.scss';
import Title from '../../shared/components/title/Title';
import Tabs from '../../shared/components/tabs/Tabs';
import { TabItem } from '../../shared/components/tabs/models/TabsModel';

interface AdminProps {
  children: React.ReactNode;
  restUrl: string;
}


const AdminPage: React.FC<AdminProps> = ({ children, restUrl }) => {
  const menuItems: TabItem[] = [
    {
      icon: 'password',
      url: `/admin/accounts`,
      label: 'Accounts',
      isActive: restUrl === 'accounts',
    },
    {
      icon: 'reports',
      url: `/admin/reports`,
      label: 'Reports',
      isActive: restUrl === 'reports',
    },
    {
      icon: 'settings',
      url: `/admin/settings`,
      label: 'Settings',
      isActive: restUrl === 'settings',
    },
    {
      icon: 'sources',
      url: `/admin/source-verification`,
      label: 'Source Verification',
      isActive: restUrl === 'source-verification',
    },
  ];

  return (
    <>
      <div className="admin-page page-content">
        <div className="page-box">
          <Title title={menuItems.filter((item) => item.isActive)[0]?.label ?? ''} />
          <Tabs items={menuItems} additionalClass="page-box__tabs" />
          <div className="page-box__content">
            <main>{children}</main>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminPage;
